
import { computed, watch, defineComponent, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import Pagination from '@/components/block/Pagination.vue'
import MagazineCardList from '@/components/block/MagazineCardList.vue'
import MagazineFooter from '@/components/block/MagazineFooter.vue'
import MagazineEventArchive from '@/components/block/MagazineEventArchive.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import { useSpecial } from '@/provider/special'
import { MagazineSpecialOutline } from '@/types/MagazineSpecial'

export default defineComponent({
  name: 'MagazinesCategory',

  components: {
    Pagination,
    MagazineCardList,
    MagazineFooter,
    MagazineEventArchive,
    HeadingLv3
  },

  setup() {
    const { state, loadCategory, loadContents } = useSpecial()
    const route = useRoute()
    const parentCategorySlug = computed(() => route.path.split('/')[2])
    const parentCategoryName = computed(
      () =>
        state.categories.find((cat) => cat.slug === parentCategorySlug.value)
          ?.name ?? ''
    )
    const parentCategories = computed(() => {
      if (parentCategorySlug.value === 'series') return state.seriesCategories
      if (parentCategorySlug.value === 'special') return state.specialCategories
      return []
    })

    const loadCategoryContents = () => {
      loadContents({
        perPage: 10,
        category: route.params.id ? Number(route.params.id) : undefined,
        page: route.query.page ? Number(route.query.page) : undefined
      })
    }
    watch(
      () => [route.params.id, route.query.page],
      (next, prev) => {
        if (JSON.stringify(next) === JSON.stringify(prev)) return
        loadCategory()
        loadCategoryContents()
      },
      { immediate: true }
    )

    const totalPages = computed(() => state.totalPages)
    const outlines = computed((): MagazineSpecialOutline[] =>
      state.contents.map((content) => ({
        ...content,
        category: content.childCategories[0]?.name ?? ''
      }))
    )

    const category = computed(() =>
      state.categories.find(
        (category) => category.id === Number(route.params.id)
      )
    )
    const title = computed(() => category?.value?.name ?? '')

    watch(
      () => [title.value, parentCategoryName.value, parentCategorySlug.value],
      (next) => {
        nextTick(() => {
          document.title = `${next[0]} 一覧 | ${next[1]} | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】`
          const lastBread = document.querySelector('.breadCrumb_list li span')
          if (lastBread) {
            lastBread.innerHTML = next[0] ?? ''
          }
          const categoryLinkBread = document.querySelector(
            '.breadCrumb_list li:nth-child(2) a'
          )
          if (categoryLinkBread) {
            categoryLinkBread.innerHTML = `${next[1]} 一覧`
            categoryLinkBread.setAttribute('href', `/magazines/${next[2]}/`)
          }
        })
      },
      { immediate: true }
    )

    return {
      parentCategories,
      totalPages,
      category,
      outlines
    }
  }
})
